var exports = {
  "ZC": "AutosaveMessageContainer__UeOIAw",
  "JX": "MessageText__Gekoy4",
  "c3": "SavedMessageText__IKdki3",
  "J$": "ErrorMessageText__WDEC5R",
};

module.exports = exports;
